import { loadStripe } from "@stripe/stripe-js";
import { Bluelagoon } from "@bluelagoon";

// Initialize Stripe with publishable key
export const stripePromise = loadStripe(Bluelagoon.getStripePublishableKey());

// Card element options
export const cardElementOptions = {
    style: {
        base: {
            fontSize: "16px",
            color: "#424770",
            "::placeholder": {
                color: "#aab7c4",
            },
        },
        invalid: {
            color: "#9e2146",
        },
    },
};
